import React from "react";
import { ChevronRight } from "@bloomberg/media-ui-icons";
import { ButtonDropdown } from "@bloomberg/media-ui-dropdown";
import { DropdownOption } from "@bloomberg/media-ui-dropdown/types";
import styles from "./wrappedHeader.module.css";

const SECTION_TITLE = "Watchlist Performance";
const YOUR_WATCHLIST_URL = `/markets/watchlist`;
const PLACEHOLDER_DROPDOWN_OPTION: DropdownOption = {
  value: "placeholder_option",
  displayValue: "Select Watchlist",
};

export function WrappedHeaderPlaceholder() {
  return (
    <div className={styles.headingContainer}>
      {/* Mobile Layout */}
      <div className={styles.mobileHeader}>
        <div className={styles.mobileTopRow}>
          <div className={styles.headingTitle}>{SECTION_TITLE}</div>
          <a className={styles.yourWatchlistMobile} href={YOUR_WATCHLIST_URL}>
            <span className={styles.watchlistWrapText}>Go to Watchlist</span>
            <span className={styles.inlineIcon}>
              <ChevronRight />
            </span>
          </a>
        </div>

        <div className={styles.watchlistViewDropdown}>
          <ButtonDropdown
            className={styles.watchlistViewDropdown}
            selectedItemOverride={PLACEHOLDER_DROPDOWN_OPTION}
            options={[]}
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            onSelect={() => {}}
          />
        </div>
      </div>

      {/* Desktop Layout */}
      <div className={styles.desktopHeader}>
        <div className={styles.desktopHeaderMain}>
          <div className={styles.headingTitle}>{SECTION_TITLE}</div>
          <div className={styles.watchlistViewDropdown}>
            <ButtonDropdown
              className={styles.watchlistViewDropdown}
              selectedItemOverride={PLACEHOLDER_DROPDOWN_OPTION}
              options={[]}
              // eslint-disable-next-line @typescript-eslint/no-empty-function
              onSelect={() => {}}
            />
          </div>
        </div>
        <a className={styles.yourWatchlist} href={YOUR_WATCHLIST_URL}>
          View Your Watchlist
          <ChevronRight />
        </a>
      </div>
    </div>
  );
}
